export function resetErrorModal() {
  return function action(dispatch) {
    dispatch({
      type: 'RESET_ERROR',
    });
  }
}

export function setBranchPK(branchPk) {
  return function action(dispatch) {
    console.log(branchPk)
    dispatch({
      type: 'SET_BRANCH_PK',
      payload: {
        branchPk
      }
    });
  }
}
